// https://stackoverflow.com/a/2901298
export const formatNumber = (number: string | number) => {
  if (!number) {
    return '-';
  }

  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
